import { portalText, usePortalTranslation } from "../../i18n/portal.js";
/**
 * The confirmation route, built here so `router.tsx` gains exactly one entry (plan-014 F3d; the support hand-off's
 * precedent, `../impersonation/impersonation-route.tsx`).
 *
 * A child of the ROOT, never of the shell: the person confirming may not be signed in — an account recovery exists
 * precisely because they cannot — and the shell's guard would send them to log in first. The token is the link's
 * FRAGMENT (`/confirm-operator-action#<token>`, MAIL's link), which never reaches a server log, a proxy or a Referer.
 */
import { createRoute, useLocation, useNavigate, type AnyRoute } from "@tanstack/react-router";
import { useEffect, useState, type ReactNode } from "react";

import { ConfirmOperatorActionScreen } from "./confirm-operator-action-screen.js";

function ConfirmOperatorActionRoute(): ReactNode {
  usePortalTranslation("core");
  const hash = useLocation({ select: (location) => location.hash.replace(/^#/, "") });
  // The token is read once and taken out of the address bar, so it lingers in no history entry or screenshot.
  const [token] = useState(hash);
  const navigate = useNavigate();
  useEffect(() => {
    if (hash !== "") void navigate({ to: "/confirm-operator-action", hash: "", replace: true });
  }, [hash, navigate]);
  return <ConfirmOperatorActionScreen token={token} />;
}

export function confirmOperatorActionRouteUnder<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/confirm-operator-action",
    staticData: { pageTitle: portalText("core", "confirm_operator_action.confirm_a_change_e86406") },
    component: ConfirmOperatorActionRoute,
  });
}
